export default {
    props: {
        size: {
            type: String,
            default: 'sm',
            validator: (val) => ['sm', 'lg'].indexOf(val) !== -1,
        },
        displayNumber: {
            type: Number,
            required: true,
        },
        isActive: {
            type: Boolean,
            required: true,
        }
    },
    methods: {
        onClick(){
            if(!this.isActive) {
                this.$emit('page', this.displayNumber);
            }
        }
    },
    render(h){
        return h(
            'button',
            {
                class: {
                    'NavButton': true,
                    'NavButton--active': this.isActive,
                    [`NavButton--${this.size}`]: true,
                },
                on: {
                    click: this.onClick
                }
            }, this.displayNumber
        );
    }
};
